import { css } from '@emotion/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Label, MediaPreview, Anchor, Form } from '@anytag/shared-atoms';
import { useTranslateCountry } from '@anytag/shared-hooks';
import { RichEditorField } from '@anytag/shared-molecules';
import { formatDate } from '@anytag/shared-utils';
import { AutoManagedCampaignFormKeys, AutoManagedCampaignFormValues } from '../types';

export const CampaignInformation = () => {
  const { t } = useTranslation();
  const { tc } = useTranslateCountry();
  const { getValues } = useFormContext<AutoManagedCampaignFormValues>();

  const values = getValues();

  return (
    <>
      <Form.SectionTitle index={1} label={t('Campaign Information')} />

      <Form.Field className="flex items-center">
        <MediaPreview className="h-30 w-30" src={values.campaignThumbnailUrl} />
        <Anchor
          lines={2}
          variant="blue"
          target="_blank"
          label={values.title}
          href={values.campaignUrl}
          className="ml-4 max-w-[464px] text-base uppercase"
        />
      </Form.Field>

      <Form.Field>
        <Label
          iconMargin="4px"
          css={styles.label}
          title={t<string>('TextForm.Campaign Title')}
          help={t('Tooltip.Campaign Title')}
        />
        <p css={[styles.text, { textTransform: 'uppercase' }]}>{values.title}</p>
      </Form.Field>

      <Form.Fields itemsPerRow={4}>
        <Form.Field>
          <Label css={styles.label} title={t<string>('TextForm.Seller Name')} />
          <p css={[styles.text, { textTransform: 'uppercase' }]}>{values.sellerName}</p>
        </Form.Field>

        <Form.Field>
          <Label css={styles.label} title={t<string>('TextForm.Campaign Duration')} />
          <p css={styles.text}>
            {!values.period.startDate && !values.period.endDate
              ? '-'
              : `${formatDate(values.period.startDate)} - ${formatDate(values.period.endDate)}`}
          </p>
        </Form.Field>
      </Form.Fields>

      <Form.Fields itemsPerRow={4}>
        <Form.Field>
          <Label css={styles.label} title={t<string>('TextForm.Campaign Country')} />
          <p css={styles.text}>{tc(values.countryName)}</p>
        </Form.Field>

        <Form.Field>
          <Label css={styles.label} title={t<string>('TextForm.Campaign Category')} />
          <p css={styles.text}>{t(values.category)}</p>
        </Form.Field>
      </Form.Fields>

      <RichEditorField<AutoManagedCampaignFormKeys>
        name="requirement"
        title={t('Post Requirements')}
        help={t('Post Requirements Help')}
        placeholder={t<string>('TextForm.Post Requirements')}
        required
      />
    </>
  );
};

const styles = {
  text: css({ fontSize: '14px' }),
  label: css({ padding: 0, fontSize: '14px', marginBottom: '8px' })
};
